import { render, staticRenderFns } from "./ReferralStatusChart.vue?vue&type=template&id=57009774&"
import script from "./ReferralStatusChart.vue?vue&type=script&lang=js&"
export * from "./ReferralStatusChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports